"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGameEscMenu = exports.toggleOpen = exports.get = exports.namespace = void 0;
var crokinoleUi_menu_main_sidecar_1 = require("./crokinoleUi_menu_main-sidecar");
exports.namespace = 'crokinoleUi_menu_esc';
var _obj = null;
function get() {
    if (!_obj) {
        _obj = create();
    }
    return _obj;
}
exports.get = get;
var create = function () {
    return {};
};
// export const setOpen = (isOpen: boolean) => {
//   let mainMenu = crokinoleUi_menu_main.get()
//   mainMenu.isGameEscOpen = isOpen
//   if (isOpen) {
//     crokinoleUi_menu_main.setOpen(true)
//   }
// }
var toggleOpen = function () {
    crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.toggleOpen('game-esc', 'in-game');
};
exports.toggleOpen = toggleOpen;
var updateGameEscMenu = function () {
    var addButton = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.addButton;
    var skipButton = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.skipButton;
    var mainMenu = crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.get();
    var isGameEscOpen = mainMenu.menuMode === 'game-esc';
    if (!isGameEscOpen) {
        return;
    }
    mainMenu.mcy = mainMenu.mcsy;
    mainMenu.mcx = mainMenu.mcsx;
    mainMenu.mcy += 400;
    addButton('game-esc-resume', 'Resume', function () {
        // setOpen(false)
        console.log(exports.namespace, 'resume');
        exports.toggleOpen();
        // crokinoleUi_menu_main.setOpen('in-game')
    }, false);
    addButton('game-options', 'Options', function () {
        crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('game-options');
    }, false);
    addButton('game-esc-back-to-lobby', 'Back to Lobby', function () {
        // setOpen(false)
        console.log(exports.namespace, 'back to lobby');
        crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('players-lobby');
    }, false);
    addButton('game-esc-back-to-main-menu', 'Back to Main Menu', function () {
        // setOpen(false)
        console.log(exports.namespace, 'back to main menu');
        crokinoleUi_menu_main_sidecar_1.crokinoleUi_menu_main.setOpen('main-menu');
    }, false);
};
exports.updateGameEscMenu = updateGameEscMenu;
